import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShop, faGavel, faCoins, faBook, faScaleBalanced, faUser, faEarListen, faChartLine, faNotesMedical, faSchool, faHammer, faReceipt, faUsersRectangle, faMoneyCheckDollar, faSackXmark, faLandmark, faPlaneDeparture, faCar, faMoneyBillTransfer } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const [lucas, setLucas] = useState(false);
    const nome = localStorage.getItem('nome');

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        if (nome === "Lucas Haber") {
            setLucas(true)
        }
        switch (user) {
            case "Administrador":
                setDirect(false)
                break;
            case "Legislador":
                await setDirect("/restrito/leis")
                break;
            case "Licitador":
                await setDirect("/restrito/licitacao")
                break;
            case "Saude":
                await setDirect("/restrito/saude")
                break;
            case "Controle Interno":
                await setDirect("/restrito/controle")
                break;
            case "Educação":
                await setDirect("/restrito/educacao")
                break;
            case "Obras":
                await setDirect("/restrito/obras")
                break;
            case "RH":
                await setDirect("/restrito/rh")
                break;
            case "Diario":
                await setDirect("/restrito/diario")
                break;
            case "Ouvidor":
                await setDirect("/restrito/ouvidoria")
                break;
        }
    }


    const redireciona = async () => {
        await getNivel();
    }

    useEffect(() => {
        redireciona()
    }, [])


    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faShop} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Licitações</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/leis')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faGavel} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo Legislativo</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/lrf')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faCoins} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de LRF</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/diario')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBook} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Diario Eletrônico</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/balanco')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faScaleBalanced} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Balanços</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/contas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faReceipt} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Contas Públicas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/ouvidoria')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faEarListen} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Ouvidoria</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        {/*<Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/divida')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faMoneyCheckDollar} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Dívida Ativa</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
        </Col>*/}
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/diarias')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faPlaneDeparture} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Tabela de Diárias de Viagens</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/atos')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faChartLine} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Atos do Governo</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/institucional')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faLandmark} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo Institucional</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/saude')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faNotesMedical} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Saúde</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/educacao')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faSchool} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Educação</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/renuncias')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faSackXmark} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Renúncia de Receitas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/rh')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faUsersRectangle} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Recursos Humanos</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/obras')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faHammer} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Obras</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/veiculos')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faCar} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Frota Municipal</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/transferenciasestado')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faMoneyBillTransfer} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Transferências Estaduais</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        {lucas ?
                            <Col>
                                <Card className='card-list' onClick={e => setDirect('/restrito/usuarios')}>
                                    <Card.Body>
                                        <Row xs={1}>
                                            <Col>
                                                <Row xs={2}>
                                                    <Col xs={3}>
                                                        <FontAwesomeIcon className='icon-cad' icon={faUser} />
                                                    </Col>
                                                    <Col xs={9}>
                                                        <p className='titulo-lei'>Módulo de Fiscais</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            : ''}
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default HomeLoggedScreen;